import { render, staticRenderFns } from "./RoomTestbankExamCreate.vue?vue&type=template&id=5d1b1b27&scoped=true&"
import script from "./RoomTestbankExamCreate.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankExamCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoomTestbankExamCreate.vue?vue&type=style&index=0&id=5d1b1b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b1b27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1b1b27')) {
      api.createRecord('5d1b1b27', component.options)
    } else {
      api.reload('5d1b1b27', component.options)
    }
    module.hot.accept("./RoomTestbankExamCreate.vue?vue&type=template&id=5d1b1b27&scoped=true&", function () {
      api.rerender('5d1b1b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Exam/RoomTestbankExamCreate.vue"
export default component.exports